export enum ActionTypes {
  // the 'GetEasePlans' action is for loading state
  GetEasePlans = 'getEasePlans',
  GetEasePlansSuccess = 'getEasePlans.success',
  GetEasePlansFailure = 'getEasePlans.failure',
}
